// const proxyPrefix = process.env.NODE_ENV === 'development' ? '/srmApi' : ''
const apiPath = '/api/partner/outside/platform'

const api = {
  srm_batchUpload: `${apiPath}/settlement/invoice/multiInvoicesRecoding`,
  srm_getCitiesInfo: `${apiPath}/performance/getCitiesInfo.do`,
  srm_settlementUserAuth: `${apiPath}/settlement/user/userAuth`,
  srm_settlementQuerySuppliers: `${apiPath}/settlement/data/querySuppliers`,
  srm_settlementDataList: `${apiPath}/settlement/data/list`,
  srm_settlementPayAheadDataList: `${apiPath}/advance/order/detail`,
  srm_settlementDataQueryById: `${apiPath}/settlement/data/queryById`,
  srm_settlementDataDetail: `${apiPath}/settlement/data/detail`,
  srm_settlementDataExportDailyDetails: `${apiPath}/settlement/data/exportDailyDetails`,
  srm_settlementOrderCreate: `${apiPath}/settlement/order/create`,
  srm_settlementOrderStatus: `${apiPath}/settlement/order/orderStatus`,
  srm_settlementOrderList: `${apiPath}/settlement/order/list`,
  srm_settlementOrderDetail: `${apiPath}/settlement/order/detail`,
  srm_settlementOrderWithdrawByOrderId: `${apiPath}/settlement/order/withdrawByOrderId`,
  srm_settlementOrderAuditByOrderId: `${apiPath}/settlement/order/auditByOrderId`,
  srm_settlementOrderProcessStatus: `${apiPath}/settlement/order/processStatus`,
  srm_settlementInvoiceSubmit: `${apiPath}/settlement/invoice/submit`,
  srm_settlementInvoiceListPayOrders: `${apiPath}/settlement/invoice/listPayOrders`,
  srm_reconcileBill_getInvoiceForm: `${apiPath}/global/config/getInvoiceForm`,
  srm_settlementInvoiceListInvoices: `${apiPath}/settlement/invoice/listInvoicesByOrderId`,
  srm_payAheadSubtypeList: `${apiPath}/advance/getSubtypeInfo`,
  srm_payAheadList: `${apiPath}/advance/data/list`,
  srm_payAheadOrderCreate: `${apiPath}/advance/order/create`,
  srm_settlementDownloadPayOrder: `${apiPath}/settlement/data/billPrint`,
  srm_polymerizedOrderList: `${apiPath}/poly/supplier/queryAll.do`,
  srm_polymerizedPayAheadOrderList: `${apiPath}/advance/order/poly`,
  srm_polymerizedWorkerOrderList: `${apiPath}/poly/query/formalStaff/fusionDetail`,
  srm_checkInvoice: `${apiPath}/settlement/agent/supplier/invoice/check`,
  // 发票提效
  srm_getInvoiceHella: `${apiPath}/invoice/getInvoice`,
  srm_getPayOrdersHella: `${apiPath}/invoice/getPayOrders`,
  srm_confirmInvoiceHella: `${apiPath}/invoice/upload/confirm`,
  srm_submitInvoiceHella: `${apiPath}/invoice/submit`,
  srm_deleteInvoiceHella: `${apiPath}/invoice/deleteInvoice`,
}

export default api
